<div
  class="flyout-profile_overlay"
  (click)="checkProfileStepCompleted()"
  (keydown.enter)="checkProfileStepCompleted()"
  tabindex="0"
>
  <div
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
    class="flyout-profile"
    tabindex="0"
  >
    <section class="flyout-profile_nav items-center">
      <div class="flex items-center gap-3">
        <ng-container *ngIf="showCheckoutComponent">
          <stxt-svg-icon
            [iconConfig]="backSvg"
            (click)="closeSettings()"
            (keydown.enter)="closeSettings()"
            tabindex="-1"
          ></stxt-svg-icon>
        </ng-container>
        <stxt-svg-icon
          *ngIf="
            isViewAllPurchases ||
            isViewAllSubscriptions ||
            isTransactionInfo ||
            isManageSubscription ||
            isVerifyScreen ||
            isManageCredential
          "
          [iconConfig]="backSvg"
          (click)="backFromAllPurchases()"
          (keydown.enter)="backFromAllPurchases()"
          tabindex="-1"
        ></stxt-svg-icon>
        <p class="flyout-profile_nav__title">{{ profileSettingsTitle$ | async }}</p>
      </div>

      <stxt-svg-icon
        *ngIf="
          !isViewAllPurchases &&
          !isViewAllSubscriptions &&
          !isTransactionInfo &&
          !isManageSubscription
        "
        [iconConfig]="closeSvg"
        (click)="closeSettings()"
        (keydown.enter)="closeSettings()"
        tabindex="-1"
      ></stxt-svg-icon>
    </section>
    <section
      *ngIf="
        !showTokensCheckoutComponent &&
        !showSubscriptionCheckoutComponent &&
        !isTransactionInfo &&
        !isManageSubscription &&
        !isViewAllPurchases &&
        !isViewAllSubscriptions &&
        !getTokensScreen &&
        !isVerifyScreen
      "
      class="flyout-profile_tabs-wrapper"
    >
      <div class="flyout-profile_tabs">
        <button
          (click)="selectTab(EProfileTab.Wallet)"
          [ngClass]="{ 'flyout-profile_tabs__tab_active': selectedTab === EProfileTab.Wallet }"
          class="flyout-profile_tabs__tab"
        >
          Wallet
        </button>
        <button
          (click)="selectTab(EProfileTab.Account)"
          [ngClass]="{ 'flyout-profile_tabs__tab_active': selectedTab === EProfileTab.Account }"
          class="flyout-profile_tabs__tab"
        >
          Account
        </button>
      </div>
    </section>
    <section
      *ngIf="selectedTab === EProfileTab.Account"
      [ngClass]="{
        'padding-subscription':
          (profileSettingsTitle$ | async) === EProfileSectionTitle.View_Subscription_Info,
        'padding-verify': isVerifyScreen,
        'padding-default':
          (profileSettingsTitle$ | async) !== EProfileSectionTitle.View_Subscription_Info &&
          !isVerifyScreen
      }"
      class="flyout-profile_account relative flex w-full"
    >
      <ng-container *ngIf="!isManageCredential && !isVerifyScreen">
        <stxt-preferences
          [interestsData]="profileUserData?.interests"
          [genderData]="profileUserData?.gender"
          [name]="profileUserData?.name"
        ></stxt-preferences>
        <stxt-security
          (openManageScreen)="openManageCredentials($event)"
          (openVerifyScreen)="openVerifyScreen()"
          [userEmail]="profileUserData?.email"
          [emailVerified]="profileUserData?.email_verified"
          [externalProvider]="profileUserData?.external_provider"
        ></stxt-security>
        <stxt-billing-info
          *ngIf="profileUserData?.email_verified"
          [billingInfo]="billingInfo"
          (billingMethodAdded)="fetchBillingInfo()"
        ></stxt-billing-info>

        <!--    TODO -- Notifications in progress-->
        <!-- <stxt-notifications></stxt-notifications> -->
        <stxt-support class="w-full" (logoutEvent)="handleLogout()"></stxt-support>
      </ng-container>
      <ng-container *ngIf="isManageCredential">
        <stxt-manage-user-credentials
          [userCredential]="credentialType"
          (credentialsUpdated)="closeSettings()"
          class="w-full h-full"
        ></stxt-manage-user-credentials>
      </ng-container>
      <ng-container *ngIf="isVerifyScreen">
        <stxt-verify-email
          [email]="profileUserData?.email"
          (emailVerified)="handleEmailVerified()"
          class="w-full h-full verify-email_section"
        ></stxt-verify-email>
      </ng-container>
    </section>

    <section
      *ngIf="selectedTab === EProfileTab.Wallet"
      class="flyout-profile_wallet relative flex-column flex w-full"
      [ngClass]="{
        'padding-subscription':
          (profileSettingsTitle$ | async) === EProfileSectionTitle.View_Subscription_Info,
        'padding-transaction':
          (profileSettingsTitle$ | async) === EProfileSectionTitle.View_Transaction_Info,
        'padding-view-all':
          (profileSettingsTitle$ | async) === EProfileSectionTitle.View_All_Purchases ||
          (profileSettingsTitle$ | async) === EProfileSectionTitle.View_All_Subscriptions
      }"
    >
      <ng-container
        *ngIf="
          !isManageSubscription &&
          !isTransactionInfo &&
          !isViewAllPurchases &&
          !isViewAllSubscriptions &&
          !showSubscriptionCheckoutComponent
        "
      >
        <stxt-tokens-card
          [billingData]="billingInfo"
          [isEditingTokens]="getTokensScreen"
          [(showCheckoutComponent)]="showCheckoutComponent"
          (showCheckoutEvent)="showCheckout($event, EPaymentType.Token)"
        ></stxt-tokens-card>
        <stxt-purchases
          *ngIf="
            subscriptionsLoaded &&
            !getTokensScreen &&
            !showTokensCheckoutComponent &&
            !showSubscriptionCheckoutComponent
          "
          [subscriptionsList]="userSubscriptions"
          [oneTimePurchase]="transactions"
          [isViewAllPurchases]="false"
          [isViewAllSubscriptions]="false"
          [activeTab]="activeWalletTab"
          (closeProfileEvent)="closeDropdown.emit(EProfileState.PROFILE_CLOSE)"
          (openTransactionInfoEvent)="openTransactionInfo($event)"
          (openSubscriptionCheckout)="showCheckout(true, EPaymentType.Subscription, $event)"
          (openSubscriptionManagementEvent)="openSubscriptionManagement($event)"
          (openAllPurchasesEvent)="openAllPurchases()"
          (openAllSubscriptionsEvent)="openAllSubscriptions()"
        ></stxt-purchases>
      </ng-container>
      <ng-container *ngIf="isManageSubscription">
        <stxt-subscription-management
          [selectedSubscription]="selectedSubscription"
          (autoRenewChange)="updateSubscription()"
          class="w-full h-full"
        ></stxt-subscription-management>
      </ng-container>
      <ng-container *ngIf="showSubscriptionCheckoutComponent">
        <stxt-checkout
          [billingData]="billingInfo"
          [creator]="selectedSubscriptionData.creator.name"
          [creatorId]="selectedSubscriptionData.creator.id"
          [firstCheckOut]="true"
          [paymentType]="EPaymentType.Subscription"
          [subscriptionData]="selectedSubscriptionData.creator.sub_plan"
          (closeCheckoutEvent)="showCheckout(false, EPaymentType.Subscription)"
          class="w-full h-full"
        ></stxt-checkout>
      </ng-container>
      <ng-container *ngIf="isTransactionInfo">
        <stxt-transaction-info [transaction]="selectedTransaction"></stxt-transaction-info>
      </ng-container>
      <ng-container *ngIf="isViewAllPurchases">
        <stxt-purchases
          [subscriptionsList]="userSubscriptions"
          [oneTimePurchase]="transactions"
          [isViewAllPurchases]="true"
          (closeProfileEvent)="closeDropdown.emit(EProfileState.PROFILE_CLOSE)"
          (openTransactionInfoEvent)="openTransactionInfo($event)"
          (openSubscriptionCheckout)="showCheckout(true, EPaymentType.Subscription, $event)"
          (openSubscriptionManagementEvent)="openSubscriptionManagement($event)"
          class="w-full h-full"
        ></stxt-purchases>
      </ng-container>
      <ng-container *ngIf="isViewAllSubscriptions">
        <stxt-purchases
          [subscriptionsList]="userSubscriptions"
          [oneTimePurchase]="transactions"
          [isViewAllSubscriptions]="true"
          (closeProfileEvent)="closeDropdown.emit(EProfileState.PROFILE_CLOSE)"
          (openTransactionInfoEvent)="openTransactionInfo($event)"
          (openSubscriptionCheckout)="showCheckout(true, EPaymentType.Subscription, $event)"
          (openSubscriptionManagementEvent)="openSubscriptionManagement($event)"
          class="w-full h-full"
        ></stxt-purchases>
      </ng-container>
    </section>
    <ng-container *ngIf="isToastMessage">
      <stxt-toast
        [toast]="toast"
        (closeToast)="isToastMessage = false"
        class="flyout-profile_toast"
      ></stxt-toast>
    </ng-container>
  </div>
</div>
